import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {PropositionBetsWidgetController} from "../proposition-bets-widget.controller";

export class PropositionBetsWidgetProps extends BaseModuleProps {
  controller: PropositionBetsWidgetController;
}
